import {
  GET_FORM_CPC_MAKER,
  RESET_CPC_MAKER,
} from 'shared/constants/ActionTypes';

const initialState = {
  form: {
    sealNoList: [
      {
        sealNo: '',
      },
      {
        sealNo: '',
      },
    ],
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_FORM_CPC_MAKER:
      return {
        ...state,
        form: action.payload,
      };
    case RESET_CPC_MAKER:
      return {
        ...state,
        form: {
          sealNoList: [
            {
              sealNo: '',
            },
            {
              sealNo: '',
            },
          ],
        },
      };
    default:
      return state;
  }
};

export default reducer;
